const sumObjectsProperty = (arr, property) => arr.reduce((sum, item) => sum + (item[property] || 0), 0);

const itemValue = (bid, amount) => bid * amount;
const itemProfit = (currentValue, investedValue) => (currentValue / investedValue) - 1;
const itemProfitMonetary = (currentValue, investedValue) => currentValue - investedValue;

const portfolioInvestedValue = items => sumObjectsProperty(items, 'investedValue');
const portfolioCurrentValue = items => sumObjectsProperty(items, 'currentValue');

const portfolioProfitLoss = (investedValue = 0, currentValue = 0) => (investedValue === 0
	? 0
	: (currentValue / investedValue) - 1);

const portfolioProfitLossMonetary = (invested, current) => current - invested;

export {
	itemValue,
	itemProfit,
	itemProfitMonetary,

	portfolioInvestedValue,
	portfolioCurrentValue,
	portfolioProfitLoss,
	portfolioProfitLossMonetary,
};
